interface FeatureItem {
  icon: string;
  title: string;
  description: string;
}

const features: FeatureItem[] = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    description: '全部综艺节目支持高清播放，智能码率自适应，画质清晰色彩饱满，带来沉浸式观看体验。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '天天更新',
    description: '每日同步各大平台最新综艺内容，热门节目上线后第一时间更新，让你追综不落后。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    description: '采用智能加速和多线路调度技术，确保播放过程稳定流畅，告别卡顿和缓冲等待。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: '电脑、平板、手机全平台适配，随时随地想看就看，通勤路上也能轻松追综艺。',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: '完全免费',
    description: '所有综艺节目无需付费、无需会员，打开就能看。真正的免费高清综艺观看平台。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide mb-3">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3">
            天天影视的核心优势
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            五大特色让你安心追综艺，享受极致的在线观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 text-center transition-all duration-300 hover:border-primary-200 cursor-default"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center transition-colors duration-300 group-hover:bg-primary-200">
                <i className={`${feature.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}